export const CUMUL = 'cumul';
export const NLI_ASSISTANT = 'nli_assistant';
export const NLI_INELIGIBILITY_UI = 'nli_ineligibility_ui';
export const RULE_AUTHORING_AGENT = 'rule_authoring_agent';
export const RULE_TESTING_AGENT = 'rule_testing_agent';
export const AVERAGE_PRIME_OFFER_RATE = 'average_prime_offer_rate';

export const PRICER_UI_REDESIGN_FRONTEND = 'pricer_ui_redesign_frontend';
export const PRICER_UI_QA_IS_MOBILE = 'pricer_ui_qa_is_mobile';

export const PRICER_UI_LOCK_DESK_WORKFLOWS = 'pricer_ui_lock_desk_workflows';
export const ENABLE_PRODUCT_CREATION_BUTTON = 'enable_product_creation_button';

export const HEDGE_UI = 'hedge_ui';

export const SET_SOURCE_RATE_SHEET_UPLOAD_INTERNAL =
  'set_source_rate_sheet_upload_internal_use';

export const NEW_SELL_SIDE_FIELDS = 'new_sell_side_fields_app_13014';

export const TOTAL_LTV = 'enable_total_ltv_on_pricer_ui';

export const ENABLE_COMPLIANCE_RULES_UI = 'enable_compliance_rules_ui';
export const ENABLE_COMPLIANCE_ADMIN_UI = 'enable_compliance_admin_ui';

export const USES_LOAN_SUB_TYPES = 'uses_loan_sub_types';

export const LOAN_ID_IN_PIPELINE_VIEWS = 'display_loan_id_in_pipeline_views';

export const PRICE_EXCEPTION_SPLIT_COUNTER_OFFER =
  'price_exception_split_counter_offer';

export const ONLY_USE_CALENDAR_FOR_EXTENSIONS =
  'only_use_calendar_for_extensions';

export const ENABLE_ENCOMPASS_PARTNER_CONNECT = 'uses_encompass_epc2';

export const RENEGOTIATION_POLICY = 'renegotiation_policy';

export const RENEGOTIATION_WORKFLOW = 'renegotiation_workflow';

export const MULT_GRIDS_AT_RESULT_EQUATION = 'mult_grids_at_result_equation';

export const FLOAT_DOWN_POLICY = 'float_down_policy';

export const FLOAT_DOWN_WORKFLOW = 'float_down_workflow';

export const WCP_ANALYSIS = 'wcp_analysis';

export const ENABLE_REUSABLE_GRIDS = 'enable_reusable_grids';

export const ENABLE_STRING_VALUE_GROUPS = 'enable_string_value_groups';

export const PE_OOO_DELEGATION = 'pe_ooo_delegation';

export const ENABLE_NOTES_COMPONENT = 'enable_notes_component';

export const ENABLE_WELLS_GAIP_EXPORT = 'enable_wells_gaip_export';

export const ENABLE_RELOCK_FEE_IN_WCP_HISTORICAL =
  'enable_relock_fee_in_wcp_historical';

export const ENABLE_ATTACHMENT_TYPE_LOCK_DESK =
  'enable_attachment_type_lock_desk';

export const ENABLE_PREPAYMENT_PENALTY_STRUCTURE_LOCK_DESK =
  'enable_prepayment_penalty_structure_lock_desk';

export const PRICE_STORY = 'price_story';

export const ENABLE_INVESTOR_DASHBOARD = 'enable_investor_dashboard';

export const SANDBOX_ACCESS = 'sandbox_access';

export const CLASSIC_UI_NEXTGEN_NAV = 'classic_ui_nextgen_nav';
